import type { Client } from '@thom/folio-domain/core/domain/client'
import type { ClientFilter } from '@thom/folio-domain/core/ports/clients'
import type { Live } from '@thom/folio-domain/core/ports/live'
import { Collections } from '@thom/folio-ui/pocketbase-types'
import { columns, toClient } from './clients-adapter'
import type { Realtime } from './realtime'

const MAX_ROWS = 500

const createClientsLive = ({ client, connection }: Realtime): Live<Client, ClientFilter> => ({
	source: { client, collection: Collections.JournClients, map: toClient, connection },
	options: filter => ({ filter: columns(filter), sort: 'name', perPage: MAX_ROWS }),
})

export { createClientsLive }
